module.exports = __webpack_public_path__ + "img/img2.90c61f7b.svg";